/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * Iaso
 * Iaso Swagger
 * OpenAPI spec version: v1
 */
import { useQuery } from 'react-query';
import type {
    InvalidateOptions,
    QueryClient,
    QueryFunction,
    QueryKey,
    UseQueryOptions,
    UseQueryResult,
} from 'react-query';

import { customFetchInstance } from '../../../../../../orval/client/custom-fetch';
import { getCustomQueryOptions } from '../../../../../../orval/mutator/custom-query-options';
import { PaginatedInstanceModificationList } from '../../models';
import type { ApiDiffInstancesListParams } from '../../models';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(
    query: T,
    queryKey: K,
): T & { queryKey: K } => {
    const result = { queryKey } as T & { queryKey: K };
    for (const key of Object.keys(query)) {
        // The explicit queryKey always wins, matching the previous
        // `{ ...query, queryKey }` spread where it was set last.
        if (key !== 'queryKey') {
            Object.defineProperty(result, key, {
                enumerable: true,
                configurable: true,
                get: () => (query as Record<string, unknown>)[key],
            });
        }
    }
    return result;
};

export const getApiDiffInstancesListUrl = (
    instanceId: string,
    params?: ApiDiffInstancesListParams,
) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(
                key,
                value === null ? 'null' : String(value),
            );
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0
        ? `${process.env.ORVAL_API_BASE_URL}/api/diff/instances/${instanceId}/?${stringifiedParams}`
        : `${process.env.ORVAL_API_BASE_URL}/api/diff/instances/${instanceId}/`;
};

export const apiDiffInstancesList = async (
    instanceId: string,
    params?: ApiDiffInstancesListParams,
    options?: RequestInit,
): Promise<PaginatedInstanceModificationList> => {
    return customFetchInstance<PaginatedInstanceModificationList>(
        getApiDiffInstancesListUrl(instanceId, params),
        {
            credentials: 'same-origin',
            ...options,
            method: 'GET',
        },
    );
};

export const getApiDiffInstancesListQueryKey = (
    instanceId: string,
    params?: ApiDiffInstancesListParams,
) => {
    return [
        'apiDiffInstancesList',
        ...(instanceId ? [instanceId] : []),
        ...(params ? [params] : []),
    ] as const;
};

export const useApiDiffInstancesListQueryOptions = <
    TData = Awaited<ReturnType<typeof apiDiffInstancesList>>,
    TError = unknown,
>(
    instanceId: string,
    params?: ApiDiffInstancesListParams,
    options?: {
        query?: UseQueryOptions<
            Awaited<ReturnType<typeof apiDiffInstancesList>>,
            TError,
            TData
        >;
        request?: SecondParameter<typeof customFetchInstance>;
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getApiDiffInstancesListQueryKey(instanceId, params);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof apiDiffInstancesList>>
    > = ({ signal }) =>
        apiDiffInstancesList(instanceId, params, { signal, ...requestOptions });

    const customOptions = getCustomQueryOptions({
        queryKey,
        queryFn,
        enabled: instanceId !== null && instanceId !== undefined,
        ...queryOptions,
    });

    return customOptions as UseQueryOptions<
        Awaited<ReturnType<typeof apiDiffInstancesList>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type ApiDiffInstancesListQueryResult = NonNullable<
    Awaited<ReturnType<typeof apiDiffInstancesList>>
>;
export type ApiDiffInstancesListQueryError = unknown;

export function useApiDiffInstancesList<
    TData = Awaited<ReturnType<typeof apiDiffInstancesList>>,
    TError = unknown,
>(
    instanceId: string,
    params?: ApiDiffInstancesListParams,
    options?: {
        query?: UseQueryOptions<
            Awaited<ReturnType<typeof apiDiffInstancesList>>,
            TError,
            TData
        >;
        request?: SecondParameter<typeof customFetchInstance>;
    },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = useApiDiffInstancesListQueryOptions(
        instanceId,
        params,
        options,
    );

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const invalidateApiDiffInstancesList = async (
    queryClient: QueryClient,
    instanceId: string,
    params?: ApiDiffInstancesListParams,
    options?: InvalidateOptions,
): Promise<QueryClient> => {
    await queryClient.invalidateQueries(
        {
            queryKey: getCustomQueryOptions({
                queryKey: getApiDiffInstancesListQueryKey(instanceId, params),
            }).queryKey,
        },
        options,
    );

    return queryClient;
};
